import React, { useContext } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import SelectAllSelectNoneButton from './SelectAllSelectNoneButton';
import { AccordionTrigger, AccordionContent } from 'components/common/Accordion'
import LocaleContext from '../../../constants/localization';

const AccessRightAccordion = ({ accessRights, checked, setChecked }) => {
  const LS = useContext(LocaleContext);

  const selectAll = (currentGroup, read) => {
    const currentGroupCheckboxes = read
      ? document.querySelectorAll(`[id^=read_${currentGroup}]`)
      : document.querySelectorAll(`[id^=write_${currentGroup}]`);
    const overlappingGroups = getOverlappingGroups(currentGroup).map(
      (g) => LS.manageGroups[g]
    );
    if (
      overlappingGroups.length > 0 &&
      !confirm(LS.manageGroups.affectsOtherAccessRights + overlappingGroups)
    )
      return;
    setChecked(
      [...checked].concat([...currentGroupCheckboxes].map((e) => e.name))
    );
  };

  const selectNone = (currentGroup, read) => {
    const currentGroupCheckboxes = read
      ? document.querySelectorAll(`[id^=read_${currentGroup}]`)
      : document.querySelectorAll(`[id^=write_${currentGroup}]`);
    const overlappingGroups = getOverlappingGroups(currentGroup).map(
      (g) => LS.manageGroups[g]
    );
    if (
      overlappingGroups.length > 0 &&
      !confirm(LS.manageGroups.affectsOtherAccessRights + overlappingGroups)
    )
      return;
    setChecked(
      checked.filter(
        (n) => ![...currentGroupCheckboxes].map((e) => e.name).includes(n)
      )
    );
  };

  const handleCheck = (name) => {
    if (checked?.includes(name)) setChecked(checked.filter((n) => n !== name));
    else setChecked([...checked, name]);
  };

  const getOverlappingGroups = (currentGroup) => {
    const { [currentGroup]: omit, ...noG } = accessRights;
    const toBeChecked = Object.values(omit).map((e) => e.uri);
    return Object.entries(noG)
      .filter(
        ([, values]) => !values.every((v) => !toBeChecked.includes(v.uri))
      )
      .map((d) => d[0]);
  };

  const content = [];
  const sortedAccessRights = Object.entries(accessRights).sort((a, b) =>
    LS.manageGroups[a[0]]?.localeCompare(LS.manageGroups[b[0]])
  );
  sortedAccessRights.forEach((predicateGroup) => {
    const accordionHeader = <div>{LS.manageGroups[predicateGroup[0]]}</div>;
    const accordionContent = [];
    accordionContent.push(
      <tr>
        <th>{LS.manageGroups.read}</th>
        <th>{LS.manageGroups.write}</th>
      </tr>
    );
    predicateGroup[1]
      .sort((a, b) => a.label.localeCompare(b.label))
      .forEach((ar) => {
        accordionContent.push(
          <tr>
            <td>
              <input
                id={`read_${predicateGroup[0]}_${ar.uri}`}
                name={`read_${ar.uri}`}
                type="checkbox"
                checked={checked.includes(`read_${ar.uri}`)}
                onChange={() => handleCheck(`read_${ar.uri}`)}
              ></input>
            </td>
            <td>
              <input
                id={`write_${predicateGroup[0]}_${ar.uri}`}
                name={`write_${ar.uri}`}
                type="checkbox"
                checked={checked.includes(`write_${ar.uri}`)}
                onChange={() => handleCheck(`write_${ar.uri}`)}
              ></input>
            </td>
            <td>{ar.label}</td>
          </tr>
        );
      });

    content.push(
      <Accordion.Item value={predicateGroup[0]}>
        <AccordionTrigger>{accordionHeader}</AccordionTrigger>
        <AccordionContent>
          <SelectAllSelectNoneButton
            selectAllRead={() => selectAll(predicateGroup[0], true)}
            selectAllWrite={() => selectAll(predicateGroup[0], false)}
            selectNoneRead={() => selectNone(predicateGroup[0], true)}
            selectNoneWrite={() => selectNone(predicateGroup[0], false)}
            group={LS.manageGroups[predicateGroup[0]]}
          />
          <table>
            <tbody>{accordionContent}</tbody>
          </table>
        </AccordionContent>
      </Accordion.Item>
    );
  });

  return (
    <>
      <SelectAllSelectNoneButton
        selectAllRead={() =>
          setChecked(
            [...checked].concat(
              Object.values(accessRights)
                .flat()
                .map((ar) => 'read_' + ar.uri)
            )
          )
        }
        selectAllWrite={() =>
          setChecked(
            [...checked].concat(
              Object.values(accessRights)
                .flat()
                .map((ar) => 'write_' + ar.uri)
            )
          )
        }
        selectNoneRead={() =>
          setChecked(checked.filter((n) => !n.startsWith('read_')))
        }
        selectNoneWrite={() =>
          setChecked(checked.filter((n) => !n.startsWith('write_')))
        }
      />
      <Accordion.Root type="multiple" collapsible="true">
        {content}
      </Accordion.Root>
    </>
  );
};

export default AccessRightAccordion;
